import "../patched/three.oc.js";
import AxisAngle from "../math/AxisAngle.js";
import "./Object3DExtensions.js";
/**
 * Schaltet das Standard-Errorhandling von Threejs "scharf" - Fehler werden nicht mehr nur geloggt,
 * sondern richtig geworfen, was ein besseres Handling während der Entwicklung ermöglicht.
 */
THREE.error = function (e) {
    throw e;
}


/**
 * Gibt die Drehung zurück, mit der man von einer Orientierung zu einer anderen gelangt.
 */
if (THREE.Quaternion.prototype.getRotationFromMeTo === undefined) {
    THREE.Quaternion.prototype.getRotationFromMeTo = function (b) {
        var a = this.clone();
        return a.invert().multiply(b);
    }
}

/**
 * Gibt den Winkel im Bogenmaß zwischen diesem und einer anderen Quaternion zurück.
 */
if (THREE.Quaternion.prototype.angleTo === undefined) {
    THREE.Quaternion.prototype.angleTo = function (otherQuaternion) {
        // https://math.stackexchange.com/questions/90081/quaternion-distance
        return Math.acos(2 * Math.pow(this.dot(otherQuaternion), 2) - 1);
    }
}

/**
 * Sind beide Quaternionen eine ähnliche Rotation?
 * garantiert true, wenn beide dieselbe Rotation darstellen. Basiert auf einer groben Einschätzung der Distanz, ist aber sehr schnell
 */
if (THREE.Quaternion.prototype.isCloseTo === undefined) {
    THREE.Quaternion.prototype.isCloseTo = function (otherQuaternion, epsilon = 0.01) {
        // https://math.stackexchange.com/questions/90081/quaternion-distance
        return 1 - Math.pow(this.dot(otherQuaternion), 2) < epsilon;
    }
}

/**
 * Gibt den Quaternion als AxisAngle Objekt zurück
 */
if (THREE.Quaternion.prototype.getAxisAngle === undefined) {
    THREE.Quaternion.prototype.getAxisAngle = function () {
        var angle = 2 * Math.acos(this.w);
        var s = Math.sqrt(1 - this.w * this.w);
        var axis = new THREE.Vector3(this.x, this.y, this.z);
        if (s > 0.001) {
            axis.multiplyScalar(1 / s);
        }
        return new AxisAngle(axis, angle);
    }
}

/**
 * Gibt die Rotationsachse des Quaternion zurück
 */
if (THREE.Quaternion.prototype.getAxis === undefined) {
    THREE.Quaternion.prototype.getAxis = function () {
        return new THREE.Vector3(this.x, this.y, this.z).normalize();
    }
}

/**
 * Berechnet das Perp-Dot-Produkt.
 * The perp dot product’s most useful property is that it gives us an easy way to compute the sine of the smaller angle between two vectors:
 * |v∗w|=|v||w|sin(α)
 * http://devmag.org.za/2009/08/12/vector-fundamentals/
 * http://cosmonautica.com/blog/2014/06/06/vectorguide/
 * taken from https://github.com/timprepscius/GeometricTools/blob/1623f4962bfaf3d5e4e42622b74664ce1b79ecf3/WildMagic5/LibMathematics/Rational/Wm5IVector2.cpp
 */
if (THREE.Vector2.prototype.dotPerp === undefined) {
    THREE.Vector2.prototype.dotPerp = function (v) {
        return this.x * v.y - this.y * v.x;
    }
}

/**
 * Interpretiert diesen Vektor als Size einer Box und prüft, ob der übergebene Vector (als Size) darin enthalten ist
 */
if (THREE.Vector3.prototype.containsSize === undefined) {
    THREE.Vector3.prototype.containsSize = function (b) {
        return this.x >= b.x && this.y >= b.y && this.z >= b.z;
    }
}

/**
 * gibt das Volumen eine Box3 zurück
 */
if (THREE.Box3.prototype.volume === undefined) {
    THREE.Box3.prototype.volume = function () {
        var size = this.getSize();
        return size.x * size.y * size.z;
    }
}

/**
 * gibt den Seiten-Mittelpunkt einer Box3-Seitenfläche zurück. side ist dabei "min" oder "max" und axis ist "x","y" oder "z".
 */
if (THREE.Box3.prototype.getFaceCenter === undefined) {
    THREE.Box3.prototype.getFaceCenter = function (side, axis) {
        const center = this.getCenter();
        center[axis] = this[side][axis];
        return center;
    }
}

/**
 * gibt die Ecken einer Box als Vector 3 zurück;
 * @returns {Array}
 */
if (THREE.Box3.prototype.getCorners === undefined) {
    THREE.Box3.prototype.getCorners = function () {
        const corners = [];
        ['min', 'max'].forEach((m) => {
            corners.push(new THREE.Vector3().copy(this[m]));
            const other = m == 'min' ? 'max' : 'min';
            ['x', 'y', 'z'].forEach(a => {
                const v = new THREE.Vector3().copy(this[m]);
                v[a] = this[other][a];
                corners.push(v);
            })
        });
        return corners;
    }
}

/**
 * https://github.com/OC-Git/Wirtschaftswunder/wiki/Grid-Koordinaten
 */
if (THREE.Box3.prototype.grid === undefined) {
    THREE.Box3.prototype.grid = function (vectorOrX, y, z) {
        const v = typeof vectorOrX === 'number'
            ? new THREE.Vector3(vectorOrX, y, z)
            : vectorOrX;
        return this.getSize().multiply(v).add(this.min);
    }
}

/**
 * stellt sicher, dass min<max ist, dass die Box also nie empty ist
 * @returns {Array}
 */
if (THREE.Box3.prototype.heal === undefined) {
    THREE.Box3.prototype.heal = function () {
        const a = this.min.clone();
        this.min.min(this.max);
        this.max.max(a);
        return this;
    }
}

/**
 * wendet ein Quaternion auf die Box an
 * @returns {Array}
 */
if (THREE.Box3.prototype.applyQuaternion === undefined) {
    THREE.Box3.prototype.applyQuaternion = function (quaternion) {
        const center = this.getCenter();
        this.translate(center.clone().multiplyScalar(-1));
        const min = this.min.clone().applyQuaternion(quaternion);
        const max = this.max.clone().applyQuaternion(quaternion);
        this.setFromPoints([min, max]);
        this.translate(center);
        return this;
    }
}

/**
 * stellt sicher, dass min<max ist, dass die Box also nie empty ist
 * @returns {Array}
 */
if (THREE.Box3.prototype.isZero === undefined) {
    const v0 = new THREE.Vector3();
    const epsilon = 0.0000001;
    THREE.Box3.prototype.isZero = function () {
        return this.min.manhattanDistanceTo(v0) < epsilon && this.max.manhattanDistanceTo(v0) < epsilon;
    }
}

/**
 * fehlt in threejs
 */
if (THREE.Vector4.prototype.distanceTo === undefined) {
    THREE.Vector4.prototype.distanceTo = function (v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
}

/**
 * fehlt in threejs
 */
if (THREE.Vector4.prototype.distanceToSquared === undefined) {
    THREE.Vector4.prototype.distanceToSquared = function (v) {
        var dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z, dw = this.w - v.w;
        return dx * dx + dy * dy + dz * dz + dw * dw;
    }
}

let debugFishyVectors_on = false;

/**
 * Wenn man nicht weiß, wo ein Vector fishy wird, kann man einfach diese Funktion zu Debugzwecken vorübergehend
 * möglichst ganz zu Anfang aufrufen (z.B. in der index.js der App oder so). Es wird dann sofort ein Error geworfen,
 * sobald irgend einem Vector ein NaN zugewiesen wird. Aber Achtung: TEUER!
 */
THREE.DebugFishyVectors = function () {

    if (debugFishyVectors_on) {
        return;
    }
    debugFishyVectors_on = true;

    function getset(prop) {
        return {
            get: function () {
                return this[prop];
            },
            set: function (v) {
                if (v == null || Number.isNaN(v)) {
                    throw new Error('attempt so set ' + prop + ' = NaN');
                }
                if (this.__onChangeCallback) {
                    this.__onChangeCallback();
                }
                this[prop] = v;
            }
        }
    }

    Object.defineProperties(THREE.Vector2.prototype, {
        'x': getset('_x'),
        'y': getset('_y'),
    });

    Object.defineProperties(THREE.Vector3.prototype, {
        'x': getset('_x'),
        'y': getset('_y'),
        'z': getset('_z')
    });

    Object.defineProperties(THREE.Vector4.prototype, {
        'x': getset('_x'),
        'y': getset('_y'),
        'z': getset('_z'),
        'w': getset('_w')
    });

    Object.defineProperties(THREE.Quaternion.prototype, {
        '_x': getset('__x'),
        '_y': getset('__y'),
        '_z': getset('__z'),
        '_w': getset('__w')
    });

};

/**
 * fehlt in threejs
 */
if (THREE.Raycaster.prototype.clone === undefined) {
    THREE.Raycaster.prototype.clone = function () {
        return new this.constructor().copy(this);
    }
}

/**
 * fehlt in threejs
 */
if (THREE.Raycaster.prototype.copy === undefined) {
    THREE.Raycaster.prototype.copy = function (v) {
        this.ray.origin.copy(v.ray.origin);
        this.ray.direction.copy(v.ray.direction);
        this.near = v.near;
        this.far = v.far;
        return this;
    }
}

/**
 * gibt die Rotationskomponente einer Matrix als Quaternion zurück
 */
if (THREE.Matrix4.prototype.getRotation === undefined) {
    THREE.Matrix4.prototype.getRotation = function () {
        const rotation = new THREE.Quaternion();
        this.decompose(new THREE.Vector3(), rotation, new THREE.Vector3());
        return rotation;
    }
}

function ObservableVector3(onChangeCallback) {
    Object.defineProperties(this, {
        'onChangeCallback': {
            value: onChangeCallback,
            enumerable: false,
            writable: true,
        },
        '_x': {
            value: 0,
            enumerable: false,
            writable: true,
        },
        '_y': {
            value: 0,
            enumerable: false,
            writable: true,
        },
        '_z': {
            value: 0,
            enumerable: false,
            writable: true,
        },
        'x': {
            enumerable: true,
            get: function () {
                return this._x;
            },
            set: function (v) {
                if (v == null || Number.isNaN(v)) {
                    throw new Error('attempt so set x = NaN');
                }
                this._x = v;
                if (this.onChangeCallback) {
                    this.onChangeCallback()
                }
            }
        },
        'y': {
            enumerable: true,
            get: function () {
                return this._y;
            },
            set: function (v) {
                if (v == null || Number.isNaN(v)) {
                    throw new Error('attempt so set y = NaN');
                }
                this._y = v;
                if (this.onChangeCallback) {
                    this.onChangeCallback()
                }
            }
        },
        'z': {
            enumerable: true,
            get: function () {
                return this._z;
            },
            set: function (v) {
                if (v == null || Number.isNaN(v)) {
                    throw new Error('attempt so set z = NaN');
                }
                this._z = v;
                if (this.onChangeCallback) {
                    this.onChangeCallback()
                }
            }
        }
    });
}

ObservableVector3.prototype = Object.create(THREE.Vector3.prototype);

// Object.defineProperties(THREE.MeshStandardMaterial.prototype, {
//     '_roughnessMap': {
//         value: null,
//         enumerable: false,
//         writable: true,
//     },
//     '_metalnessMap': {
//         value: null,
//         enumerable: false,
//         writable: true,
//     },
//     'roughnessMap': {
//         enumerable: true,
//         get: function() {
//             return this._roughnessMap;
//         },
//         set: function(m) {
//             this._roughnessMap = m;
//         }
//     },
//     'metalnessMap': {
//         enumerable: true,
//         get: function() {
//             return this._metalnessMap;
//         },
//         set: function(m) {
//             this._metalnessMap = m;
//         }
//     }
// });

/**
 * initWithObservation erzeugt eine neue, modifizierte Vector3 - Instanz,
 * welche eine Callback-Methode bei jeder Änderung aufruft. Ein mit dieser Methode erzeugter
 * Vector ist weniger performant als ein normaler Vector, da alle Zugriffe auf x,y,z intern über
 * Getter/Setter - Methoden laufen.
 * @example
 * const vector = THREE.Vector3.initWithObservation(()=>{
 *    console.log('I was changed');
 * });
 * vector.x=5; // => 'I was changed'
 */
THREE.Vector3.initWithObservation = function (onChangeCallback) {
    const o = new ObservableVector3()
    o.onChangeCallback = onChangeCallback;
    return o;
};


/**
 * Speichern / Laden diverser Grundobjekte als JSON Format
 */
THREE.Vector2.prototype.toJSON = function () {
    return {x: this.x, y: this.y};
}
THREE.Vector3.prototype.toJSON = function () {
    return {x: this.x, y: this.y, z: this.z};
}
THREE.Vector4.prototype.toJSON = function () {
    return {w: this.w, x: this.x, y: this.y, z: this.z};
}
THREE.Quaternion.prototype.toJSON = function () {
    return {w: this.w, x: this.x, y: this.y, z: this.z};
}
THREE.Euler.prototype.toJSON = function () {
    return {x: this.x, y: this.y, z: this.z, order: this.order};
}
THREE.Color.prototype.toJSON = function () {
    return this.getHex();
}
THREE.Box2.prototype.toJSON = function () {
    return {min: this.min.toJSON(), max: this.max.toJSON()};
}
THREE.Box3.prototype.toJSON = function () {
    return {min: this.min.toJSON(), max: this.max.toJSON()};
}
THREE.Line3.prototype.toJSON = function () {
    return {start: this.start.toJSON(), end: this.end.toJSON()};
}
THREE.Plane.prototype.toJSON = function () {
    return {normal: this.normal.toJSON(), constant: this.constant};
}
THREE.Ray.prototype.toJSON = function () {
    return {origin: this.origin.toJSON(), direction: this.direction.toJSON()};
}
THREE.Sphere.prototype.toJSON = function () {
    return {center: this.center.toJSON(), radius: this.radius};
}


THREE.Vector2.prototype.fromJSON = function (json) {
    this.set(json.x, json.y);
    return this;
}
THREE.Vector3.prototype.fromJSON = function (json) {
    this.set(json.x, json.y, json.z);
    return this;
}
THREE.Vector4.prototype.fromJSON = function (json) {
    this.set(json.x, json.y, json.z, json.w);
    return this;
}
THREE.Quaternion.prototype.fromJSON = function (json) {
    this.set(json.x, json.y, json.z, json.w);
    return this;
}
THREE.Euler.prototype.fromJSON = function (json) {
    this.set(json.x, json.y, json.z, json.order);
    return this;
}
THREE.Color.prototype.fromJSON = function (hex) {
    this.set(hex);
    return this;
}
THREE.Box2.prototype.fromJSON = function (json) {
    this.set(THREE.Vector2.fromJSON(json.min), THREE.Vector2.fromJSON(json.max));
    return this;
}
THREE.Box3.prototype.fromJSON = function (json) {
    this.set(THREE.Vector3.fromJSON(json.min), THREE.Vector3.fromJSON(json.max));
    return this;
}
THREE.Line3.prototype.fromJSON = function (json) {
    this.set(THREE.Vector3.fromJSON(json.start), THREE.Vector3.fromJSON(json.end));
    return this;
}
THREE.Plane.prototype.fromJSON = function (json) {
    this.set(THREE.Vector3.fromJSON(json.normal), json.constant);
    return this;
}
THREE.Ray.prototype.fromJSON = function (json) {
    this.set(THREE.Vector3.fromJSON(json.origin), THREE.Vector3.fromJSON(json.direction));
    return this;
}
THREE.Sphere.prototype.fromJSON = function (json) {
    this.set(THREE.Vector3.fromJSON(json.center), json.radius);
    return this;
}


THREE.Vector2.fromJSON = function (json) {
    return json == null ? null : new THREE.Vector2().fromJSON(json);
}
THREE.Vector3.fromJSON = function (json) {
    return json == null ? null : new THREE.Vector3().fromJSON(json);
}
THREE.Vector4.fromJSON = function (json) {
    return json == null ? null : new THREE.Vector4().fromJSON(json);
}
THREE.Quaternion.fromJSON = function (json) {
    return json == null ? null : new THREE.Quaternion().fromJSON(json);
}
THREE.Color.fromJSON = function (json) {
    return json == null ? null : new THREE.Color().fromJSON(json);
}
THREE.Box2.fromJSON = function (json) {
    return json == null ? null : new THREE.Box2().fromJSON(json);
}
THREE.Box3.fromJSON = function (json) {
    return json == null ? null : new THREE.Box3().fromJSON(json);
}
THREE.Line3.fromJSON = function (json) {
    return json == null ? null : new THREE.Line3().fromJSON(json);
}
THREE.Plane.fromJSON = function (json) {
    return json == null ? null : new THREE.Plane().fromJSON(json);
}
THREE.Ray.fromJSON = function (json) {
    return json == null ? null : new THREE.Ray().fromJSON(json);
}
THREE.Sphere.fromJSON = function (json) {
    return json == null ? null : new THREE.Sphere().fromJSON(json);
}


/**
 * vergleicht nur die Koordinaten auf Gleichheit bezüglich eines epsilons
 */
if (THREE.Vector2.prototype.isEqualEpsilon === undefined) {
    THREE.Vector2.prototype.isEqualEpsilon = function (other, epsilon = 0.000001) {
        return other != null && Math.abs(other.x - this.x) < epsilon && Math.abs(other.y - this.y) < epsilon;
    }
}
if (THREE.Vector3.prototype.isEqualEpsilon === undefined) {
    THREE.Vector3.prototype.isEqualEpsilon = function (other, epsilon = 0.000001) {
        return other != null && Math.abs(other.x - this.x) < epsilon && Math.abs(other.y - this.y) < epsilon && Math.abs(other.z - this.z) < epsilon;
    }
}
if (THREE.Vector4.prototype.isEqualEpsilon === undefined) {
    THREE.Vector4.prototype.isEqualEpsilon = function (other, epsilon = 0.000001) {
        return other != null && Math.abs(other.x - this.x) < epsilon && Math.abs(other.y - this.y) < epsilon && Math.abs(other.z - this.z) < epsilon && Math.abs(other.w - this.w) < epsilon;
    }
}
if (THREE.Quaternion.prototype.isEqualEpsilon === undefined) {
    THREE.Quaternion.prototype.isEqualEpsilon = function (other, epsilon = 0.000001) {
        return other != null && Math.abs(other.x - this.x) < epsilon && Math.abs(other.y - this.y) < epsilon && Math.abs(other.z - this.z) < epsilon && Math.abs(other.w - this.w) < epsilon;
    }
}
if (THREE.Matrix3.prototype.isEqualEpsilon === undefined) {
    THREE.Matrix3.prototype.isEqualEpsilon = function (other, epsilon = 0.000001) {
        if (other == null || other.elements == null || other.elements.length != this.elements.length) {
            return false;
        }
        for (let i = 0; i < this.elements.length; i++) {
            if (Math.abs(other.elements[i] - this.elements[i]) < epsilon) {
                return false;
            }
        }
        return true;
    }
}
if (THREE.Matrix4.prototype.isEqualEpsilon === undefined) {
    THREE.Matrix4.prototype.isEqualEpsilon = function (other, epsilon = 0.000001) {
        if (other == null || other.elements == null || other.elements.length != this.elements.length) {
            return false;
        }
        for (let i = 0; i < this.elements.length; i++) {
            if (Math.abs(other.elements[i] - this.elements[i]) < epsilon) {
                return false;
            }
        }
        return true;
    }
}
if (THREE.Box3.prototype.isEqualEpsilon === undefined) {
    THREE.Box3.prototype.isEqualEpsilon = function (other, epsilon = 0.000001) {
        return other != null && this.min.isEqualEpsilon(other.min,epsilon) && this.max.isEqualEpsilon(other.max,epsilon);
    }
}
if (THREE.Box2.prototype.isEqualEpsilon === undefined) {
    THREE.Box2.prototype.isEqualEpsilon = function (other, epsilon = 0.000001) {
        return other != null && this.min.isEqualEpsilon(other.min,epsilon) && this.max.isEqualEpsilon(other.max,epsilon);
    }
}

/**
 * Source-Kompatibilität zu < r108
 */
if (THREE.Quaternion.prototype.onChange === undefined) {
    THREE.Quaternion.prototype.onChange = function (callback) {
        return this._onChange(callback);
    }
}

